'use client'
import { createPageCommitTelemetry } from '@brew/observability/browser'
import { PAGE_COMMIT_CONTRACTS } from './page-commit-contracts.runtime.generated'
export const pageCommit = createPageCommitTelemetry(PAGE_COMMIT_CONTRACTS)
